import apiClient from '@/services/axios'

export async function listAllOrganizations() {
  return apiClient.get('/organizations')
}

export async function getOrganizationByID(id) {
  try {
    const response = await apiClient.get(`/organizations/${id}`)
    if (response.data) {
      return {
        success: true,
        status: 200,
        message: 'Organization data',
        data: response.data,
      }
    } else {
      return {
        success: false,
        status: 404,
        data: {},
        message: `Organization with id: ${id} not found!`,
      }
    }
  } catch (error) {
    return {
      success: false,
      status: 500,
      message: 'Error fetching Organization by ID',
      error,
    }
  }
}

export function createOrganization(organization) {
  return apiClient.post('/organizations', organization)
}

export async function uploadLogo(organizationId, file) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('id', organizationId);

    return await apiClient.post('/organizations/uploadPfp', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
}

export async function updateOrganization(id, organizationData) {
  return apiClient.patch(`/organizations/${id}`, organizationData)
}

// Settings-only endpoints. GET /organizations/:id hydrates depots/vehicles/
// employees/states (a massive payload for a populated org), so anything that
// just needs a platform flag must use these instead.
export async function getOrganizationSettings(id) {
  return apiClient.get(`/organizations/${id}/settings`)
}

export async function updateOrganizationSettings(id, settingsPatch) {
  return apiClient.patch(`/organizations/${id}/settings`, settingsPatch)
}

export async function deleteOrganization(id) {
  return apiClient.delete(`/organizations/${id}`)
}

// New S3 presign/commit-based upload helpers for organization logo
export function presignOrganizationLogo(organizationId, contentType) {
  return apiClient.post(`/organizations/${organizationId}/logo/presign`, {
    contentType,
  })
}

export function commitOrganizationLogo(organizationId, { key, userId }) {
  return apiClient.post(`/organizations/${organizationId}/logo/commit`, {
    key,
    userId,
  })
}

export async function uploadOrganizationLogo(organizationId, file, userId) {
  const { data: presignRes } = await presignOrganizationLogo(
    organizationId,
    file.type,
  )
  const { url, key } = presignRes

  const putRes = await fetch(url, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  })
  if (!putRes.ok) throw new Error('S3 upload failed')

  const { data: commitRes } = await commitOrganizationLogo(organizationId, {
    key,
    userId,
  })
  return commitRes.url
}